module.exports = __webpack_public_path__ + "static/media/icon-pag-boleto.753f5d42.svg";